import styled from 'styled-components';
import { PageHeader } from 'antd';

export const BreederAdminsPageHeader = styled(PageHeader)`
  padding: 0 0.5rem 0.5rem;
`;
